import * as React from 'react';
import * as ReactDOM from 'react-dom';

import {$$} from '../util/$$';
import {Scans} from './view/Scans';
import {StateProvider} from './view/StateContext';
import {Text, TextContext} from './TextContext';
import {WordPressContext, WordPressData} from './data/WordPressData';

// tslint:disable-next-line max-func-body-length
export function quickscan(): void {
    const elements: HTMLElement[] = $$('.js-quickscan');

    if (elements.length === 0) {
        return;
    }

    const wordPressData: WordPressData[] = elements.map(
        (element: HTMLElement): WordPressData =>
            JSON.parse(element.getAttribute('data-posts') as string),
    );
    const wordpressContext: WordPressContext = JSON.parse(elements[0].getAttribute('data-wp') as string);
    const text: Text = JSON.parse(
        elements[0].getAttribute('data-text') as string,
    );

    ReactDOM.render(
        <TextContext.Provider value={text}>
            <StateProvider data={wordPressData} context={wordpressContext}>
                    <Scans/>
            </StateProvider>
        </TextContext.Provider>,
        elements[0],
    );
}
